<template>
    <div>
        <v-cookie></v-cookie>
        <div v-html="content"></div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            content:'',
            id:this.$route.query.id,
        }
    },
    mounted() {
        this.getSmsTxtContent();
    },
    methods:{
        getSmsTxtContent(){
            let that = this;
            let data = {'id':this.id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/fax/getfaxconttxtcontent.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.content = res.data.content;
                    
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
    
}
</script>



// WEBPACK FOOTER //
// src/components/fax/showfaxtxtcontent.vue